// SSoT for community URL pinning (?c=<id>).
// Every tab carries its active community in the URL so tabs can work on
// different communities in parallel. This module decides which paths are
// community-scoped and stamps links with the tab's community so that
// "open in new tab" / copied links land on the same community.

export const COMMUNITY_SCOPED_PREFIXES = [
  '/app/products',
  '/app/groups',
  '/app/scheduled-messages',
  '/app/activity',
  '/app/analytics',
  '/app/coupons',
  '/app/orders',
  '/app/settings',
  '/app/tools',
]

export function isCommunityScopedPath(path) {
  if (path === '/app' || path === '/app/') return true // dashboard
  return COMMUNITY_SCOPED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(prefix + '/')
  )
}

// Append ?c=<communityId> to a path/URL string (no-op for non-community
// paths, missing ids, or links that already carry an explicit c).
export function withCommunityParam(path, communityId) {
  if (!communityId || typeof path !== 'string') return path
  const [beforeHash, hash] = path.split('#')
  const pathnameOnly = beforeHash.split('?')[0]
  if (!isCommunityScopedPath(pathnameOnly)) return path
  if (/[?&]c=/.test(beforeHash)) return path
  const stamped = beforeHash + (beforeHash.includes('?') ? '&' : '?') + 'c=' + communityId
  return hash !== undefined ? stamped + '#' + hash : stamped
}
